export default __webpack_public_path__ + "static/media/bg12.6bd451a8.jpg";